(function () {
    'use strict';

    const storyStage = document.querySelector('[data-story-stage]');

    if (storyStage) {
        const slides = Array.from(storyStage.querySelectorAll('[data-story-slide]'));
        const choices = Array.from(document.querySelectorAll('[data-story-choice]'));
        const previous = storyStage.querySelector('[data-story-previous]');
        const next = storyStage.querySelector('[data-story-next]');
        const count = storyStage.querySelector('[data-story-count]');
        const total = document.querySelector('[data-story-total]');
        let activeStory = 0;
        let storyTimer;

        const showStory = (index) => {
            if (!slides.length) {
                return;
            }

            activeStory = (index + slides.length) % slides.length;

            slides.forEach((slide, slideIndex) => {
                const isActive = slideIndex === activeStory;
                slide.hidden = !isActive;
                slide.classList.toggle('is-active', isActive);
            });

            choices.forEach((choice, choiceIndex) => {
                choice.setAttribute('aria-current', choiceIndex === activeStory ? 'true' : 'false');
            });

            if (count) {
                count.textContent = `Story ${activeStory + 1} of ${slides.length}`;
            }
        };

        const startStoryRotation = () => {
            window.clearInterval(storyTimer);

            if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                return;
            }

            storyTimer = window.setInterval(() => showStory(activeStory + 1), 6500);
        };

        choices.forEach((choice) => {
            choice.addEventListener('click', () => {
                showStory(Number(choice.dataset.storyIndex));
                startStoryRotation();
            });
        });

        if (previous) {
            previous.addEventListener('click', () => {
                showStory(activeStory - 1);
                startStoryRotation();
            });
        }

        if (next) {
            next.addEventListener('click', () => {
                showStory(activeStory + 1);
                startStoryRotation();
            });
        }

        if (total) {
            total.textContent = `${slides.length}-story rotation`;
        }

        if (slides.length < 2) {
            if (previous) previous.disabled = true;
            if (next) next.disabled = true;
        }

        showStory(0);
        startStoryRotation();
    }

    const ticker = document.querySelector('.oo-market-ticker');

    const cloneTicker = () => {
        if (!ticker) {
            return;
        }

        const tickerSet = ticker.querySelector('[data-ticker-set]');
        const tickerClone = ticker.querySelector('[data-ticker-clone]');

        if (!tickerSet || !tickerClone) {
            return;
        }

        tickerClone.replaceChildren(...Array.from(tickerSet.children).map((item) => item.cloneNode(true)));
    };

    if (ticker) {
        const pause = ticker.querySelector('[data-ticker-pause]');

        if (pause) {
            pause.addEventListener('click', () => {
                const isPaused = ticker.classList.toggle('is-paused');
                pause.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
                pause.textContent = isPaused ? 'Resume ticker' : 'Hover to pause';
            });
        }

        cloneTicker();
    }

    const videoDesk = document.querySelector('.oo-video-desk');
    let videos = [];
    let activeVideo = 0;
    let videoTimer;

    const validVideoId = (videoId) => /^[A-Za-z0-9_-]{11}$/.test(videoId || '');

    const clearVideoMedia = (thumb) => {
        thumb.querySelectorAll('img, iframe').forEach((element) => element.remove());
        thumb.classList.remove('has-player');
    };

    const showVideo = (index) => {
        if (!videoDesk || !videos.length) {
            return;
        }

        const thumb = videoDesk.querySelector('[data-video-thumb]');
        const title = videoDesk.querySelector('[data-video-title]');
        const meta = videoDesk.querySelector('[data-video-meta]');
        const why = videoDesk.querySelector('[data-video-why]');
        const status = videoDesk.querySelector('[data-video-status]');
        const choices = Array.from(videoDesk.querySelectorAll('[data-video-choice]'));
        const video = videos[(index + videos.length) % videos.length];

        activeVideo = (index + videos.length) % videos.length;
        clearVideoMedia(thumb);
        thumb.classList.toggle('has-video', validVideoId(video.videoId));

        if (video.thumbnail || validVideoId(video.videoId)) {
            const image = document.createElement('img');
            image.src = video.thumbnail || `https://i.ytimg.com/vi/${video.videoId}/hqdefault.jpg`;
            image.alt = '';
            image.loading = 'lazy';
            thumb.prepend(image);
        }

        title.textContent = video.title || 'Oil-market video briefing';
        meta.textContent = [video.channel, video.published, video.duration].filter(Boolean).join(' · ');
        why.textContent = video.why || 'Selected for its relevance to today’s oil investors.';
        status.textContent = `Video ${activeVideo + 1} of ${videos.length} · refreshed at 6:30 AM and 5:00 PM ET`;

        choices.forEach((choice, choiceIndex) => {
            choice.setAttribute('aria-current', choiceIndex === activeVideo ? 'true' : 'false');
        });
    };

    const startVideoRotation = () => {
        window.clearInterval(videoTimer);

        if (videos.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        videoTimer = window.setInterval(() => showVideo(activeVideo + 1), 8500);
    };

    const loadVideos = (items) => {
        if (!videoDesk || !Array.isArray(items)) {
            return;
        }

        videos = items.filter((item) => item && item.title).slice(0, 6);

        if (!videos.length) {
            return;
        }

        const queue = videoDesk.querySelector('[data-video-queue]');
        queue.replaceChildren();

        videos.forEach((video, index) => {
            const choice = document.createElement('button');
            choice.type = 'button';
            choice.className = 'oo-video-choice';
            choice.dataset.videoChoice = '';
            choice.setAttribute('aria-current', index === 0 ? 'true' : 'false');
            choice.textContent = `${String(index + 1).padStart(2, '0')} · ${video.shortTitle || video.title}`;
            choice.addEventListener('click', () => {
                showVideo(index);
                startVideoRotation();
            });
            queue.append(choice);
        });

        const play = videoDesk.querySelector('[data-video-play]');

        play.addEventListener('click', () => {
            const selected = videos[activeVideo];

            if (!selected || !validVideoId(selected.videoId)) {
                return;
            }

            const thumb = videoDesk.querySelector('[data-video-thumb]');
            clearVideoMedia(thumb);

            const frame = document.createElement('iframe');
            frame.src = `https://www.youtube-nocookie.com/embed/${selected.videoId}?autoplay=1&rel=0`;
            frame.title = selected.title;
            frame.loading = 'lazy';
            frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            frame.allowFullscreen = true;
            thumb.prepend(frame);
            thumb.classList.add('has-player');
            window.clearInterval(videoTimer);

            const status = videoDesk.querySelector('[data-video-status]');
            status.textContent = `Video ${activeVideo + 1} of ${videos.length} · rotation paused while playing`;
        });

        showVideo(0);
        startVideoRotation();
    };

    const updateMarket = (market) => {
        if (!market || !Array.isArray(market.items)) {
            return;
        }

        market.items.forEach((item) => {
            if (!item || !item.symbol) {
                return;
            }

            document.querySelectorAll(`[data-market-symbol="${CSS.escape(item.symbol)}"]`).forEach((row) => {
                const price = row.querySelector('.oo-ticker-price');
                const change = row.querySelector('.oo-ticker-change');

                if (price) price.textContent = item.price || '—';

                if (change) {
                    change.textContent = item.change || '—';
                    change.classList.toggle('is-up', item.direction === 'up');
                    change.classList.toggle('is-down', item.direction === 'down');
                }

                if (item.url && row.tagName === 'A') {
                    row.href = item.url;
                }
            });

            const watchRow = document.querySelector(`[data-watch-symbol="${CSS.escape(item.symbol)}"]`);

            if (watchRow) {
                const value = watchRow.querySelector('em');
                value.textContent = [item.price, item.change].filter(Boolean).join(' ');
                value.classList.toggle('is-up', item.direction === 'up');
                value.classList.toggle('is-down', item.direction === 'down');
            }
        });

        const updated = document.querySelector('[data-market-updated]');
        const watchlistStamp = document.querySelector('[data-watchlist-stamp]');
        const updateText = [market.updated && `Updated ${market.updated}`, market.source && `Source: ${market.source}`, market.delay].filter(Boolean).join(' · ');

        if (updated && updateText) updated.textContent = updateText;
        if (watchlistStamp && market.updated) watchlistStamp.textContent = `Updated ${market.updated}`;

        if (market.briefing) {
            const briefPrice = document.querySelector('[data-brief-price]');
            const briefWhy = document.querySelector('[data-brief-why]');
            const briefImpact = document.querySelector('[data-brief-impact]');
            const briefWatch = document.querySelector('[data-brief-watch]');

            if (briefPrice && market.briefing.price) briefPrice.textContent = market.briefing.price;
            if (briefWhy && market.briefing.why) briefWhy.textContent = market.briefing.why;
            if (briefImpact && market.briefing.impact) briefImpact.textContent = market.briefing.impact;
            if (briefWatch && market.briefing.watch) briefWatch.textContent = market.briefing.watch;
        }

        cloneTicker();
    };

    const applyFeed = (feed) => {
        if (!feed || typeof feed !== 'object') {
            return;
        }

        updateMarket(feed.market || feed);
        loadVideos(feed.videos);
    };

    const dataServiceUrl = ticker?.dataset.marketFeed || videoDesk?.dataset.videoFeed;

    if (window.OILOUTLOOK_FEED) {
        applyFeed(window.OILOUTLOOK_FEED);
    } else if (dataServiceUrl) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 8000);

        fetch(dataServiceUrl, {
            credentials: 'omit',
            headers: {'Accept': 'application/json'},
            signal: controller.signal
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`OilOutlook data service returned ${response.status}`);
                }

                return response.json();
            })
            .then(applyFeed)
            .catch(() => {
                const updated = document.querySelector('[data-market-updated]');
                if (updated) updated.textContent = 'Live data is temporarily unavailable; no stale prices are being shown.';
            })
            .finally(() => window.clearTimeout(timeout));
    }
}());
